export const serverUrl = 'https://kibano4ka.ge-co.io';
export const hubIndexId = 'c8cc05e0-cc65-11ec-bb40-8d6007a0b1cc';
export const gecoAnalyticIndexId = 'd90b7e20-daa9-11ec-bb40-8d6007a0b1cc';